if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };
      this.mql = window.matchMedia('(min-width: 750px)');
      this._isNavigating = false;

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 100));

      this.elements.thumbnails.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-target]');
        if (!thumb) return;
        e.preventDefault();
        e.stopPropagation();
        this.navigateInstant(thumb.dataset.target);
      });

      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    navigateInstant(mediaId) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;

      const slider = this.elements.viewer.slider || this.elements.viewer.querySelector('[id^="Slider-"]');
      if (!slider) return;

      this._isNavigating = true;

      slider.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      this.setActiveThumbnail(mediaId);

      slider.style.setProperty('scroll-behavior', 'auto', 'important');
      slider.style.setProperty('scroll-snap-type', 'none', 'important');
      slider.scrollLeft = activeMedia.offsetLeft;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          slider.style.removeProperty('scroll-behavior');
          slider.style.removeProperty('scroll-snap-type');
          this._isNavigating = false;
        });
      });

      this.playActiveMedia(activeMedia);
    }

    onSlideChanged(event) {
      if (this._isNavigating) return;
      if (!event.detail.currentElement) return;
      this.setActiveThumbnail(event.detail.currentElement.dataset.mediaId);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;

      const slider = activeMedia.parentElement;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
      activeMedia.classList.add('is-active');

      this.preventStickyHeader();
      this.setActiveThumbnail(mediaId);

      if (slider) {
        slider.style.setProperty('scroll-behavior', 'auto', 'important');
        slider.style.setProperty('scroll-snap-type', 'none', 'important');
        slider.scrollLeft = activeMedia.offsetLeft;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            slider.style.removeProperty('scroll-behavior');
            slider.style.removeProperty('scroll-snap-type');
          });
        });
      }

      if (scrollIntoView && (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked')) {
        activeMedia.scrollIntoView({ behavior: 'auto' });
      }

      this.playActiveMedia(activeMedia);
    }

    setActiveThumbnail(mediaId) {
      if (!this.elements.thumbnails) return;

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach(t => {
        t.classList.remove('is-active');
        t.removeAttribute('aria-current');
      });

      const thumb = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      if (!thumb) return;
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');

      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      this.elements.liveRegion.setAttribute('aria-hidden', false);
      this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace('[index]', position);
      setTimeout(() => {
        this.elements.liveRegion.setAttribute('aria-hidden', true);
      }, 2000);
    }

    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) {
        window.pauseAllMedia();
        deferredMedia.loadContent(false);
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
